/**
 * Porcentaje de avance de una OC según cantidades de ítems (documentos + guías de entrada).
 */
export function getPurchaseOrderProgressPercent(order) {
  if (order?.fulfillment_percent != null && !Number.isNaN(Number(order.fulfillment_percent))) {
    return Math.min(100, Math.max(0, Math.round(Number(order.fulfillment_percent))));
  }
  if (!order?.items?.length) return 0;

  const totalQuantity = order.items.reduce(
    (sum, item) => sum + parseFloat(item.quantity || 0),
    0,
  );
  const usedQuantity = order.items.reduce((sum, item) => {
    const qty = parseFloat(item.quantity || 0);
    const pendingQty =
      item.pending_quantity !== undefined ? parseFloat(item.pending_quantity || 0) : qty;
    return sum + Math.max(0, qty - pendingQty);
  }, 0);

  return totalQuantity > 0 ? Math.round((usedQuantity / totalQuantity) * 100) : 0;
}

export function countPendingPurchaseOrderItems(order) {
  if (!order?.items?.length) return { pending: 0, total: 0 };
  const pending = order.items.filter((item) => parseFloat(item.pending_quantity || 0) > 0.001).length;
  return { pending, total: order.items.length };
}

/** Etiqueta de estado sin porcentaje (el avance va en la barra). */
/** Solo consulta (cancelada o completada al 100% sin cierre manual). Las cerradas manualmente se reabren con Abrir. */
export function isPurchaseOrderReadOnly(order) {
  if (!order) return false;
  if (order.status === 'cancelled') return true;
  if (order.fulfillment_closed_at || order.is_fulfillment_closed) return false;
  const percent = getPurchaseOrderProgressPercent(order);
  return percent >= 100;
}

export function canReopenPurchaseOrder(order) {
  if (!order || order.status === 'cancelled') return false;
  return Boolean(order.fulfillment_closed_at || order.is_fulfillment_closed);
}

export function getPurchaseOrderFulfillmentLabel(order) {
  if (!order) return { label: '—', className: 'bg-gray-100 text-gray-700' };
  if (order.fulfillment_status === 'partial') {
    return { label: 'Parcial', className: 'bg-amber-50 text-amber-800' };
  }
  if (order.fulfillment_status === 'completed') {
    return { label: 'Completada', className: 'bg-blue-50 text-blue-800' };
  }
  if (order.status === 'cancelled') {
    return { label: 'Cancelada', className: 'bg-red-50 text-red-700' };
  }
  return { label: 'Emitida', className: 'bg-green-50 text-green-700' };
}
